<template>
  <div style="display: contents;">
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container>
            <b-row>
              <b-col sm="12">
                <!-- {{params}} -->
                <b-table-simple stacked="sm" striped caption-top  class="table table-sm text-center">
                  <caption class="pl-2 pl-sm-0 pb-0"><h6 class="package-title" v-translate>Passengers details</h6></caption>
                  <b-thead class="t-head thead-light text-center">
                    <b-tr>
                      <b-td>#</b-td>
                      <b-td v-translate>Title</b-td>
                      <b-td><translate>Last name</translate>*</b-td>
                      <b-td><translate>First name</translate>*</b-td>
                      <b-td><translate>Age</translate></b-td>
                      <b-td><translate>Date of birth</translate>*</b-td>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <template v-for="(p, pIndex) in pax">
                      <PaxForm
                        v-model="pax[pIndex]"
                        :id="'pax' + pIndex"
                        :key="'pax' + pIndex"
                        :travelDate="travelDate"
                      />
                    </template>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <hr class="mb-0">
                <p style="margin-bottom:0;"><em>*<translate>Fields marked with asterisks are required.</translate></em></p>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col>
                <h6><translate>Agent notes</translate></h6>
                <textarea v-model="notes" class="form-control">...</textarea>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="7">
                <b-card no-body class="px-2 py-1">
                  <ValidationProvider
                    name="terms"
                    rules="is:acceptat"
                    vid="terms"
                    v-slot="vContext"
                    slim
                  >
                    <b-form-group>
                      <b-form-checkbox
                        id="conditions"
                        name="conditions"
                        v-model="termsAccepted"
                        :state="getValidationState(vContext)"
                        aria-describedby="conditions-live-feedback"
                        value="acceptat"
                        unchecked-value="neacceptat"
                        >
                         <small class="text-dark"> <translate>I have read and agree to the </translate><span class="text-info"  @click="openTermsAndConditions" v-translate>Terms and Conditions</span> <translate>of the marketing products.</translate></small>
                        </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)"><translate>you have not accepted the terms and conditions</translate></b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-card>
              </b-col>
              <b-col md="5">
                <b-card
                  class="card-booking-price text-white text-center"
                  style="font-size:1.1rem;"
                >
                  <b-form-group>
                    <span><translate>Price</translate>: &nbsp;&nbsp;<span class="font-weight-bold">{{ result.gross }} {{ params.currency }} </span> <small>(<translate>tax included</translate>)</small></span>
                  </b-form-group>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card
                  bg-variant="light"
                  no-body
                >
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="warning" size="sm" @click="close" class="mb-2 mb-md-0"><b-icon icon="chevron-left" /><translate>Back</translate></b-button>
                        <b-button variant="warning" size="sm" type="submit" v-translate>Book</b-button>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" title="Status" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner :label="$gettext('Loading') + '...'" variant="primary"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" title="Error" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class=" font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
           <translate>There was a problem</translate>
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted"> - <translate>Unfortunately the reservation could not be registered because a problem occurred</translate>.</b-card-text>
          <b-card-text class="lead text-muted"> - <translate>Generally, this happens when the price or availability of the product has changed since you searched</translate>.</b-card-text>
          <b-card-text class="lead text-muted"> <translate>The error message is</translate>: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="close" v-translate>Close</b-button>
      </b-card>
    </b-modal>
    <b-modal v-model="termsAndConditions" :title="$gettext('Terms and Conditions')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <TermsAndConditions/>
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsAndConditions" v-translate>Book</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from 'b2b-common/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import PaxForm from '@/app/private/shared/components/pax_form'
import TermsAndConditions from '../../shared/components/terms_conditions'
import { $gettext } from '@/config/gettext'

import { book } from 'b2b-common/services/api/other'

const invalidFormMessage = $gettext('Invalid Form')

export default {
  mixins: [toast, auth, validation],
  props: ['params', 'result'],
  components: { PaxForm, TermsAndConditions },
  computed: {
    duration () {
      return moment(this.params.return_date, 'DD-MM-YYYY').startOf('day').diff(moment(this.params.date, 'DD-MM-YYYY').startOf('day'), 'days')
    },
    travelDate () { return moment(this.params.date, 'DD-MM-YYYY') }
  },
  data () {
    const pax = []
    for (let i = 0; i < this.params.adults; i++) {
      pax.push({
        title: 'MR',
        fname: '',
        lname: '',
        age: 'adult',
        bdate: null
      })
    }
    this.params.child_ages.forEach(age => {
      pax.push({
        title: (age < 2) ? 'INF' : 'CHD',
        fname: '',
        lname: '',
        age: age,
        bdate: null
      })
    })

    return {
      model,
      notes: '',
      pax,
      termsAccepted: $gettext('unaccepted'),
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: $gettext('unknown error'),
      termsAndConditions: false
    }
  },
  methods: {
    close () {
      this.$emit('closeModal')
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    async book () {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: $gettext('Please fill in all required fields!'), variant: 'danger' })
          throw new Error(invalidFormMessage)
        }
        this.showOverlay = true
        this.overlayMessage = $gettext('Please wait, we check again the price and availability of the selected product ...')

        const pax = this.pax.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate
        }))

        // now ok to create booking
        const bookParams = {
          result: this.result.index,
          notes: this.notes,
          pax: pax
        }

        const res = await book(bookParams)
        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
        throw err
      } finally { this.showOverlay = false }
    }
  }
}
</script>
